var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-24",
  "use": "meta-24-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-24\"><path d=\"M23.849 6.009H7.373C6.614 6.009 6 6.635 6 7.408v18.199h1.373v-2.8h1.602v2.8h1.373v-2.8h1.602v2.8h1.373v-2.8h1.602v2.8h1.373v-2.8H17.9v2.8h1.373v-2.8h1.602v2.8h1.373v-2.8h1.602v2.8h1.373V7.408c-.003-.773-.617-1.399-1.375-1.399zm-16.476 2.1c0-.387.307-.7.686-.7h15.104c.379 0 .686.313.686.7v13.3H7.373v-13.3zm1.372 9.799h13.73v1.4H8.745v-1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol